export default "__VITE_ASSET__BqOQMJ6L__"